import { createSelector } from 'reselect';
import { getProjectSyncState } from 'src/modules/project-sync/selectors/getProjectSyncState';

export const getProjectSyncData = createSelector([
  getProjectSyncState,
], (state) => state.data);
